import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Provider } from '../webApi/DataModels'
import { map, filter } from 'lodash'
import constants from '@/constants'

class ProviderState {
  public providers: Provider[] = []
  public activeProviders: Provider[] = []
  public providerOptions: any[] = []
  public activeProviderOptions: any[] = []
}

const mutations = <MutationTree<ProviderState>>{
  setProviders (state: ProviderState, providers: Provider[]) {
    state.providers = providers
    state.providerOptions = providers.map((provider: Provider) => {
      return {
        value: provider.Provider_ID,
        label: provider.Provider_Name,
        selected: false
      }
    })
    window.sessionStorage.setItem('Provider_List', JSON.stringify(state.providers))
  },
  setActiveProviders (state: ProviderState, activeProviders: any[]) {
    state.activeProviders = activeProviders
    state.activeProviderOptions = activeProviders.map((provider: any) => {
      return {
        value: provider.Provider_ID,
        label: provider.Provider_Name,
        selected: false
      }
    })
    window.sessionStorage.setItem('Active_Provider_List', JSON.stringify(state.activeProviders))
  },
  reset (state:ProviderState) {
    state.providers = []
    state.activeProviders = []
    state.providerOptions = []
    state.activeProviderOptions = []
  }
}

const actions = <ActionTree<ProviderState, any>>{
  reset (store: ActionContext<ProviderState, any>):void {
    store.commit('reset')
  },
  loadProviders (store: ActionContext<ProviderState, any>):Promise<any> {
    return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.PROVIDER, permissionValue: constants.PERMISSION_VALUES.LIST }, { root: true })
      .then((hasPermission): any => {
        if (!hasPermission) {
          return Promise.resolve('not needed')
        } else {
          if (window.sessionStorage.getItem('Provider_List') != null) {
          // the list has already been stored in session
            store.commit('setProviders', JSON.parse(window.sessionStorage.getItem('Provider_List')))
            return Promise.resolve('success')
          } else {
          // the list has not been stored in session yet, load from server
            return webApi.provider.get_Providers().then(
              (response) => {
              // Store the response
                store.commit('setProviders', response.data)
                return Promise.resolve('success')
              }).catch((response) => {
              window.bus.$emit('openErrorModal', 'error loading providers: ' + response.ExceptionMessage)
              return Promise.reject(response)
            })
          }
        }
      })
  },
  loadActiveProviders (store: ActionContext<ProviderState, any>):Promise<any> {
    return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.PROVIDER, permissionValue: constants.PERMISSION_VALUES.LIST }, { root: true })
      .then((hasPermission): any => {
        if (!hasPermission) {
          return Promise.resolve('not needed')
        } else {
          if (window.sessionStorage.getItem('Active_Provider_List') != null) {
          // the list has already been stored in session
            store.commit('setActiveProviders', JSON.parse(window.sessionStorage.getItem('Active_Provider_List')))
            return Promise.resolve('success')
          } else {
          // the list has not been stored in session yet, load from server
            return webApi.provider.get_Active_Providers().then(
              (response) => {
                // Store the response
                store.commit('setActiveProviders', response.data)
                return Promise.resolve('success')
              }).catch((response) => {
              window.bus.$emit('openErrorModal', 'error loading providers: ' + response.ExceptionMessage)
              return Promise.reject(response)
            })
          }
        }
      })
  }
}

const getters = <GetterTree<ProviderState, any>>{
  providers: (state) => {
    return state.providers
  },
  activeProviders: (state) => {
    return state.activeProviders
  },
  providerOptions: (state) => {
    return state.providerOptions
  },
  activeProviderOptions: (state) => {
    return state.activeProviderOptions
  },
  providerNames (state:ProviderState):any {
    return (providerIDs:number[]) => {
      return map(filter(state.providers, provider => (providerIDs.indexOf(provider.Provider_ID) > -1)), 'Provider_Name')
    }
  }
}
export default ({
  namespaced: true,
  state: new ProviderState(),
  mutations,
  actions,
  getters
})
